<form class="stream-setting-form" [formGroup]="form">
  <div class="row mt-3">
    <div class="text-dark font-weight-bold col-3" translate>
      UI.Categories.CategoryName
    </div>
    <div class="text-dark font-weight-bold col-7" translate>
      {{ 'UI.Categories.CategoryTags' | translate }} ({{
        'Just hit enter to add a tag, spaces allowed' | translate
      }})
    </div>
    <div class="text-dark font-weight-bold col-2 text-center" translate>
      {{ 'UI.Categories.ShowCategories' | translate }} (<span
        >{{ activeCategory }}/{{ MAX_ACTIVE_CATEGORIES_AMOUNT }}</span
      >)
    </div>
  </div>

  <div formArrayName="categories">
    <ng-container
      *ngFor="let category of form?.get('categories')?.controls; let i = index"
    >
      <ng-container
        *ngIf="
          !isCreating && !editable
            ? shouldShowCategoryInViewMode(category)
            : true
        "
      >
        <div [formGroupName]="i" class="row mt-2">
          <ng-container>
            <div class="col-3">
              <div>
                <app-form-field-custom
                  [formInput]="form.get('categories')?.at(i)"
                  [editable]="editable"
                  [options]="{
                    placeholder: 'Enter category',
                    readonly:
                      isOrgCategorySettings &&
                      form.get('categories')?.at(i)?.value.IsTenantCategory
                  }"
                  [type]="allType.StringSingle"
                  [attributeDescription]="getFieldOptions('CategoryName')"
                  [controlName]="'CategoryName'"
                >
                </app-form-field-custom>
              </div>
            </div>
          </ng-container>
          <div class="col-7">
            <div class="category-tags">
              <app-tag-field-category
                [editable]="editable"
                [items]="
                  form.get('categories')?.at(i)?.controls['CategoryTags']?.value
                "
                [editableTag]="!isOrgCategorySettings"
                (itemsChange)="setTagValue($event, i)"
              ></app-tag-field-category>
              <div
                *ngIf="
                  form
                    .get('categories')
                    ?.at(i)
                    ?.controls['CategoryTags']?.hasError('required')
                "
                class="alert alert-danger"
              >
                {{ 'Field is required.' | translate }}
              </div>
            </div>
          </div>

          <ng-container>
            <div class="col-2 text-center">
              <app-check-box
                #checkbox
                [elementId]="'isActivated' + i"
                [isChecked]="
                  form.get('categories')?.at(i)?.controls['IsActivated']?.value
                "
                [disabled]="shouldDisableCheckbox(checkbox.isChecked)"
                [tooltip]="getTooltip(checkbox.isChecked) | translate"
                [tooltipClass]="'category-checkbox-tooltip'"
                (selectItem)="setCheckboxValue($event, i)"
              ></app-check-box>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>
